module.exports = __webpack_public_path__ + "img/Jump Casting79.e572dda1.jpg";